/**
 * 
 * File loader is build specific to Nura case where we need to load the file 
 * 
 * Initially we had seperate application for loading files , 
 * But that did not work well so we have to move to on premise 
 * 
 * @author Ashique Mohammed
 * @author Marvan
 * 
 */
import React, { useEffect, useState, useContext } from 'react';

import { message, Button, Skeleton, Result } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import { DocDetails } from './../../models';

import { PdfViewer } from 'soxo-bootstrap-core';

import moment from 'moment-timezone';

import { useTranslation } from 'soxo-bootstrap-core';

import './file-loader.scss';

let reportTypes = {
    RAW: 'json',
    JSON: 'json',
    VCF: 'vcf',
    IMG: 'png',
    RPT: 'pdf',
    pdf: 'pdf',
    png: 'png'
};

let reportContentType = {
    RAW: 'application/json',
    JSON: 'application/json',
    VCF: 'text/vcard',
    IMG: 'image/png',
    RPT: 'application/pdf',
    pdf: 'application/pdf',
    png: 'image/png'
};

/**
 * Component to load the report from file server
 *
 * @param {*} param0
 */
export default function FileLoader({
    config = {
        requireLinuxPath: false,
        replaceBranch: false,
    },
    url,
    type,
    defaultScale,
    viewerType,
    ...props
}) {
    // Variable to save the file url
    const [digitalreport, setDigitalReport] = useState(null);

    //To manage
    const [emptyFileData, setemptyFileData] = useState(false);

    const { t, i18n } = useTranslation(); // To Translate to another language

    let curretDate = moment().format('DD-MM-YYYY') + Math.round(Math.random() * Math.pow(9, 10));

    useEffect(() => {
        // Load the pdf with the url received
        loadPDF(url);
    }, [url]);

    /**
     * Replace the filename with BLR for any other branch
     * This is a custom implementation for Nura
     *
     * @param {*} fileName
     * @returns
     *
     * @author Ashique Mohammed
     */
    function replaceFileName(fileName, requireLinuxPath, replaceFileName) {

        if (replaceFileName) {
            const wordsToReplace = ['DEL', 'BOM', 'HYD', 'CCJ'];

            // // The path has to be changed to bangalore
            const replacementString = 'BLR';

            // // To replace if its either of the strings and case insensitive
            // const regex = new RegExp(wordsToReplace.join('|'), 'i');

            // Below is temporary and will be moved to backend

            // #Note For use in mongolia below 
            // return fileName
            //     .replaceAll('\\\\', '////')
            //     .replaceAll('\\', '//')
            //     .replaceAll('tbn-his-appfs', 'TBN-HIS-APPFS')
            //     .trim();
            // return fileName.replace('\\', '/');

            // const wordsToReplace = ["DEL", "BOM"];

            // // The path has to be changed to bangalore
            // const replacementString = "BLR";

            // // To replace if its either of the strings and case insensitive
            // const regex = new RegExp(wordsToReplace.join("|"), "i");

            // const wordsToReplace = ['DEL', 'BOM'];

            // The path has to be changed to bangalore
            // const replacementString = 'BLR';

            // To replace if its either of the strings and case insensitive
            const regex = new RegExp(wordsToReplace.join('|'), 'i');

            fileName = fileName.replace(regex, replacementString);
        } else {
            fileName = fileName;
        }
        // return fileName;

        // We need to get the raw path and replace it for use in linux
        // For normal we dont want that .
        return requireLinuxPath ? String.raw`${fileName}`.replace(/\\/g, '/') : fileName;
    }

    /**
     * Load the file from the particular path
     *
     * @param {*} report_link
     * @returns
     */
    async function loadPDF(report_link) {
        let filePath = report_link;

        // We have 4 cases two handle here
        // Case 1 - Application hosted on linux and require a replacement for url - No Usecase right now
        // Case 2 - Application hosted on linux and does not require a replacement for url - For local site - hyderabad
        // Case 3 - Application hosted on windows an require a replacement of url  - For Remote Usage - delhi / mumbai / hyderabad
        // Case 4 - Application hosted on windows and do not require a replace of url - For Local Site Usage - Mumbai

        // For the linux vm we require file structure to be changed
        filePath = replaceFileName(report_link, config.requireLinuxPath, config.replaceBranch);

        let updatedFilePath = capitalizeBetweenSlashes(filePath);

        // if (config.requireLinuxPath) {

        //     //
        //     filePath = replaceFileName(report_link, config.replaceBranch);

        // } else if ((config.requireLinuxPath && config.replaceBranch) == false) {

        //     filePath = filePath;

        // } else {
        //     filePath = replaceFileName(report_link, true);
        // }

        // message.loading('Loading digital report');

        const uncompressedArray = await DocDetails.loadFile(config, updatedFilePath.trim(), reportTypes[type], props);

        if (uncompressedArray) {
            var fileImage = new Blob([uncompressedArray], { type: `${reportContentType[type]}` });

            var fileURL = URL.createObjectURL(fileImage);

            // window.open(fileURL);

            setDigitalReport(fileURL);
        } else {
            setemptyFileData(true);
        }
    }

    function downloadJSON() {
        var name = url.fileName ? url.fileName : curretDate;
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = digitalreport;
        link.download = name;
        link.click();
        window.URL.revokeObjectURL(digitalreport);
        link.remove();
    }

    /**
     * Function to capitalize the text between the first '//' and the next '/' in a given string.
     * 
     * @param {string} str - The input string, e.g. "//example/Files/path".
     * @returns {string} - The string with the text between '//' and '/' capitalized.
     */
    const capitalizeBetweenSlashes = (str) => {
        // Regular expression to find the text between '//' and the first '/' after it.
        // The (.*?) captures any characters between '//' and the first '/' non-greedily.
        const match = str.match(/\/\/(.*?)\//);

        // Check if a match is found and if there's any captured text.
        if (match && match[1]) {
            // Capitalize the captured text (i.e., the part between '//' and '/').
            const textToCapitalize = match[1].toUpperCase();

            // Replace the original captured text with its capitalized version.
            return str.replace(match[1], textToCapitalize);
        }

        // If no match is found, return the original string without changes.
        return str;
    };

    /**
     *
     */
    function reportPreview(selected) {

        if (viewerType) {
            // Show iframe if viewerType is true
            return (
                <iframe
                    align="center"
                    src={digitalreport}
                    width="100%"
                    height="700px"
                ></iframe>
            );
        }
        switch (selected) {
            case 'pdf':
                return <PdfViewer url={digitalreport} defaultScale={defaultScale} />;
                // return <iframe align="center" src={digitalreport} width="100%" height="700px"></iframe>
                break;
            case 'png':
                return <img src={digitalreport} style={{ width: '100%', maxWidth: '800px', height: 'auto' }} />;
                break;
            case 'json':
                return (
                    <a target="_blank" rel="noreferrer" className={`report-link vehicle-card card`}>
                        <h1>{t('JSON')}</h1>
                        <Button onClick={downloadJSON} type="secondary" size={'small'}>
                            {t('Download')}
                        </Button>
                    </a>
                );
                break;
            case 'vcf':
                return (
                    <a target="_blank" rel="noreferrer" className={`report-link vehicle-card card`}>
                        <h1>{t('VCF')}</h1>
                        <Button onClick={downloadJSON} type="secondary" size={'small'}>
                            {t('Download')}
                        </Button>
                    </a>
                );
                break;
            default:
                return <PdfViewer url={digitalreport} defaultScale={defaultScale} />;
        }
    }

    return (
        <>
            {/* {digitalreport ? <img src={digitalreport} style={{ width: '100%', height: '400px' }} /> : null} */}
            {digitalreport ? (
                <div>{reportPreview(reportTypes[type])}</div>
            ) : emptyFileData ? (
                <div className="warning-section">
                    <Result
                        status="warning"
                        title={<span className="custom-title">We have no file to load.</span>}
                        icon={<WarningOutlined className="custom-icon" />}
                        className="custom-result"
                    />
                </div>
            ) : (
                <Skeleton />
            )}
        </>
    );
}
